<template>
  <article class="lamella-card" @click="$emit('open', lamella.id)">
    <div class="lamella-card__top">
      <div>
        <div class="lamella-card__name">{{ lamella.name }}</div>
        <div class="lamella-card__meta">{{ lamella.currentStage || "No stage" }}</div>
      </div>
      <LamellaStatusBadge :status="lamella.status" />
    </div>
    <div v-if="previewImage" class="lamella-card__preview">
      <img :src="previewImage" :alt="lamella.name" loading="lazy" />
    </div>
    <div v-if="lamella.notes" class="lamella-card__notes">{{ lamella.notes }}</div>
    <div class="lamella-card__footer">
      <span>{{ lamella.imageRefs?.length || 0 }} images</span>
      <button v-if="!readonly" class="lamella-card__delete" @click.stop="$emit('delete', lamella.id)">Delete</button>
    </div>
  </article>
</template>

<script setup>
import { computed } from "vue";
import LamellaStatusBadge from "./LamellaStatusBadge.vue";

const props = defineProps({
  lamella: {
    type: Object,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["delete", "open"]);

const previewImage = computed(() => props.lamella.imageRefs?.[0]?.url || null);
</script>

<style scoped>
.lamella-card {
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 1rem;
  background:
    radial-gradient(circle at top right, rgba(56, 189, 248, 0.12), transparent 8rem),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 0.9rem;
  cursor: pointer;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;
}
.lamella-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.08);
  border-color: rgba(14, 165, 233, 0.35);
}
.lamella-card__top,
.lamella-card__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.lamella-card__name { font-weight: 700; color: #111827; }
.lamella-card__meta,
.lamella-card__footer { color: #6b7280; font-size: 0.78rem; }
.lamella-card__preview {
  margin-top: 0.7rem;
}
.lamella-card__preview img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 0.85rem;
  background: #e2e8f0;
}
.lamella-card__notes { margin-top: 0.5rem; color: #374151; font-size: 0.82rem; }
.lamella-card__delete {
  border: none;
  background: transparent;
  color: #b91c1c;
  cursor: pointer;
  font-weight: 600;
}
</style>
